export const DEFAULT_ZOOM_LEVEL = 10;
export const UK_MARKETPLACE_ID = "EBAY-GB";
export const DE_MARKETPLACE_ID = "EBAY-DE";
export const AU_MARKETPLACE_ID = "EBAY-AU";
export const DEFAULT_DISTANCE = "3";
export const LONDON_CENTER: google.maps.LatLngLiteral = {
  lat: 51.506307,
  lng: -0.145552,
};
export const BERLIN_CENTER: google.maps.LatLngLiteral = {
  lat: 52.520008,
  lng: 13.404954,
};
export const SYDNEY_CENTER: google.maps.LatLngLiteral = {
  lat: -33.865143,
  lng: 151.2099,
};
export const DEFAULT_MARKETPLACE_CENTER: Record<string, google.maps.LatLngLiteral> = {
  [UK_MARKETPLACE_ID]: LONDON_CENTER,
  [DE_MARKETPLACE_ID]: BERLIN_CENTER,
  [AU_MARKETPLACE_ID]: SYDNEY_CENTER,
};
export const UNKNOWN_POSITION: google.maps.LatLngLiteral = {
  lat: 0,
  lng: 0,
};
export const DEFAULT_MAP_PADDING = 1;
export const DEFAULT_RADIUS_M = 30000;
export const DEFAULT_CLUSTER_RADIUS = 150;
export const DEFAULT_EXTENT = 512;
export const MAX_ZOOM_LEVEL = 20;
export const SHOW_CIRCLES_ZOOM_LEVEL = 15;
export const CIRCLE_STROKE_COLOR = "#3665F3";
export const CIRCLE_STROKE_WEIGHT = 1.5;
export const ACTIVE_CIRCLE_FILL_OPACITY = 0.1;
export const STACKED_CLUSTER_PRECISION = 5;
export const MARKER_Z_INDEX = 1;
export const ACTIVE_MARKER_Z_INDEX = 1000;
export const USER_LOCATION_MARKER_Z_INDEX = 999;
export const MIN_DESKTOP_WIDTH = 1100;
export const SHOW_WALKING_DISTANCE_CIRCLE_ZOOM_LEVEL = 13;
export const WALKING_DISTANCE_BOUNDS_PADDING_DESKTOP = 100;
export const WALKING_DISTANCE_BOUNDS_PADDING_MOBILE = 50;
export const MIN_MOBILE_WIDTH = 512;
export const HYPER_LOCAL_DISTANCE = 3;
export const SCROLL_TO_MARKER_DEBOUNCE_MS = 1000;
export const MAP_SCROLL_ANIMATION_DURATION_MS = 750;
export const DESKTOP_BANNER_INSERT_POSITIONS = [9, 18];
export const MOBILE_BANNER_INSERT_POSITIONS = [8, 16];
